var _excluded = ["children", "tone", "helpText", "onAction", "destructive"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { classNames } from '../../../../utilities/css.js';
import styles from './SecondaryAction.scss.js';
import { Button } from '../../../Button/Button.js';
import { Tooltip } from '../../../Tooltip/Tooltip.js';
function SecondaryAction(_ref) {
  var children = _ref.children,
    tone = _ref.tone,
    helpText = _ref.helpText,
    onAction = _ref.onAction,
    destructive = _ref.destructive,
    rest = _objectWithoutProperties(_ref, _excluded);
  var buttonMarkup = /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onAction,
    tone: destructive ? 'critical' : undefined
  }, rest), children);
  var actionMarkup = helpText ? /*#__PURE__*/React.createElement(Tooltip, {
    preferredPosition: "below",
    content: helpText
  }, buttonMarkup) : buttonMarkup;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.SecondaryAction, tone === 'critical' && styles.critical)
  }, actionMarkup);
}
export { SecondaryAction };